import { render, staticRenderFns } from "./FreePaymentLinks.vue?vue&type=template&id=6beb6d58&scoped=true"
import script from "./FreePaymentLinks.vue?vue&type=script&lang=js"
export * from "./FreePaymentLinks.vue?vue&type=script&lang=js"
import style1 from "./FreePaymentLinks.vue?vue&type=style&index=1&id=6beb6d58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beb6d58",
  null
  
)

export default component.exports